import Group from 'components/utils/Group'
import React from 'react'
import { PropsWithChildren } from 'react'
import styled from 'styled-components'

const AccommodationPackageTileInclusionsGroup = styled(Group)``

function AccommodationPackageTileInclusions(props: PropsWithChildren) {
  return <AccommodationPackageTileInclusionsGroup {...props} direction="vertical" gap={8} />
}

export default AccommodationPackageTileInclusions
